module.exports = __webpack_public_path__ + "static/media/aluminio-lamina.c2763250.jpg";